const doc = [({"ja":({"adminButtonHotelCalendar":({"deleteSpecifiedStaysOnlyPeriod":"泊数限定期間を削除"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;